import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { Grid, Button } from "@material-ui/core";

export default function SimpleDialog(props) {
    const { onClose, open, data} = props;

    const handleClose = () => {
        onClose();
    };

    // onClose={handleClose} 
    return (
        <Dialog maxWidth='xs' fullWidth={true} aria-labelledby="simple-dialog-title" open={open}>
            <div className='modalBody p-4' >

                <Grid container>
                    <Grid item className='mb-4 text-center' xs={12}>
                    <div>
                        <p>הקורונה לימדה את כולנו (בוודאי בענף התיירות) עד כמה החיים יכולים להשתנות ברגע.. מרגעים של צחוק לרגעים מצחיקים פחות (וההפך). בדיוק בשביל הרגעים האלה השקנו את שירות - הזמנה הגמישה! </p>
                        <p>הרוכשים שירות זה יוכלים לבטל את חופשתם מכל סיבה (והלוואי והסיבות תמיד יהיו טובות!) ולקבל את מרבית כספם בחזרה - בלי ניירת, בלי בירוקרטיה, בלי שאלות וטירטורים. </p>
                        <p>תוכלו להודיע לנו עד {data} ימים לפני יום ההמראה על רצונכם לבטל את ההזמנה ותקבלו את ההחזר הכספי המובטח לכם במהירות - הכל בשקיפות ובמינימום התעסקות.</p>
                    </div>    
                    </Grid>
                    <Grid item className='text-center' xs={12}><Button onClick={handleClose} variant='contained' color='secondary'>סגור</Button></Grid>


                </Grid>
            </div>

        </Dialog>
    );
}